import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { PRIMARY } from "../../../utils/constansColors";
// import { Gap, MyButton } from "../../atoms";
// import { useParams } from "react-router-dom";
// import { Link } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    fontSize: "25px",
    borderRadius: 5,
  },
  tableHeader: {
    backgroundColor: "transparant",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    color: "#757575",
    fontWeight: 700,
  },
});

const columnData = [
  { no: 0, name: "No" },
  { no: 1, name: "Nama" },
  // { no: 2, name: "NIK" },
	{ no: 3, name: "No KTA" },
	// { no: 4, name: "Jenis Kelamin" },
	// { no: 5, name: "Status Perkawinan" },
	// { no: 6, name: "Tempat Lahir" },
	// { no: 7, name: "Tanggal Lahir" },
	{ no: 8, name: "No Handphone" },
	{ no: 9, name: "Alamat" },
	{ no: 10, name: "Alamat Domisili" },
	// { no: 11, name: "Foto KTP" },
	{ no: 11, name: "Waktu Daftar" },
];
export default function BasicTable() {
	// let params = useParams();
  // const dispatch = useDispatch();
  const classes = useStyles();
  // let navigate = useNavigate();

  const dataDaftarAnggota = useSelector((state) => state.daftarAnggota.dataDaftarAnggota);
  
	// const persentase = (penyebut,pembagi) =>{
	// 	let persen = 0
	// 	if(pembagi !== 0){
	// 		persen = ((penyebut/pembagi)*100).toFixed(0)
	// 	}
	// 	return persen
	// }

	// const convertDate = (time) => {
	// 	let date = new Date(time);
	// 	return `${((date.getDate()<10)?"0":"") + date.getDate()}/${((date.getMonth()+1<10)?"0":"") + (date.getMonth() + 1)}/${date.getFullYear()}`
	// }
	const convertTime = (time) => {
		let date = new Date(time);
		return `${((date.getDate()<10)?"0":"") + date.getDate()}/${((date.getMonth()+1<10)?"0":"") + (date.getMonth() + 1)}/${date.getFullYear()}, ${((date.getHours()<10)?"0":"") + date.getHours()}:${((date.getMinutes()<10)?"0":"") + date.getMinutes()}:${((date.getMinutes()<10)?"0":"") + date.getMinutes()}`
	}
  return (
    <>
      <TableContainer>
        <Table
          // md={{ minWidth: 1500 }}
          aria-label="simple table"
          className={classes.tableHeader}
					style={{minWidth: 1000}}
        >
          <TableHead>
            <TableRow>
              {columnData.map((item, key) => {
                return (
                  <TableCell
                    key={key}
                    style={{
											padding:'8px',
                      fontWeight: 700,
                      color: "#757575",
											textAlign:'center',
                      width: item.name === "No" ? "30px" : (item.name === "Alamat" || item.name === "Alamat Domisili")? "200px":"",
                    }}
                  >
										{<div>{item.name}</div>}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        </Table>
				<div style={{height:"400px", minWidth:'1000px', overflowY:'auto', overflowX:'hidden'}}>
        {dataDaftarAnggota?.data?.data?.map((item, index) => {
          let number = index + 1 + ((dataDaftarAnggota?.data?.current_page-1)*10);
          return (
            <Table
              // sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={classes.tableBody}
              key={"tab-" + index}
							style={{minWidth: 1000 }}
            >
              <TableBody>
                <TableRow key={item.id}>
                  <TableCell style={{ padding:'8px',width: "30px", fontSize:'12px' }}>{number}</TableCell>
									<TableCell style={{ padding:'8px', fontSize:'12px'}}>
										<div style={{ wordWrap: "break-word" }}>
											{item?.data_pribadi?.name}
										</div>
									</TableCell>
									{/* <TableCell style={{ padding:'8px', fontSize:'12px'}}>
										{item?.data_pribadi?.nik}
									</TableCell> */}
									<TableCell style={{ padding:'8px', fontSize:'12px'}}>
										{item?.data_pribadi?.no_kta}
									</TableCell>
									{/* <TableCell style={{ padding:'8px', fontSize:'12px'}}>
										{item?.data_pribadi?.jenis_kelamin}
									</TableCell> */}
									{/* <TableCell style={{ padding:'8px', fontSize:'12px'}}>
										{(item?.data_pribadi?.status_perkawinan === 1)?"Sudah Kawin":(item?.data_pribadi?.status_perkawinan === 0)?"Belum Kawin":"Pernah Kawin"}
									</TableCell> */}
									{/* <TableCell style={{ padding:'8px', fontSize:'12px'}}>
										<div style={{ wordWrap: "break-word" }}>
											{item?.data_pribadi?.tempat_lahir}
										</div>
									</TableCell> */}
									{/* <TableCell style={{ padding:'8px', fontSize:'12px'}}>
										{convertDate(item?.data_pribadi?.tgl_lahir)}
									</TableCell> */}
									<TableCell style={{ padding:'8px', fontSize:'12px'}}>
										{item?.data_pribadi?.no_handphone}
									</TableCell>
									<TableCell style={{ width:'200px',padding:'8px', fontSize:'12px'}}>
										<div style={{ wordWrap: "break-word" }}>
											<span style={{fontSize:'9px'}}>Alamat : </span>{item?.data_ktp?.alamat}<br/>
											<span style={{fontSize:'9px'}}>RT/RW : </span>{item?.data_ktp?.rt}/{item?.data_ktp?.rw}<br/>
											<span style={{fontSize:'9px'}}>Kelurahan : </span>{item?.data_ktp?.nama_kelurahan}<br/>
											<span style={{fontSize:'9px'}}>Kecamatan : </span>{item?.data_ktp?.nama_kecamatan}<br/>
											<span style={{fontSize:'9px'}}>Kab/Kota : </span>{item?.data_ktp?.nama_kab_kot}<br/>
											<span style={{fontSize:'9px'}}>Provinsi : </span>{item?.data_ktp?.nama_provinsi}
										</div>
									</TableCell>
                  <TableCell style={{ width:'200px',padding:'8px', fontSize:'12px'}}>
										<div style={{ wordWrap: "break-word" }}>
											<span style={{fontSize:'9px'}}>Alamat : </span>{item?.alamat_domisili?.alamat}<br/>
											<span style={{fontSize:'9px'}}>RT/RW : </span>{item?.alamat_domisili?.rt}/{item?.alamat_domisili?.rw}<br/>
											<span style={{fontSize:'9px'}}>Kelurahan : </span>{item?.alamat_domisili?.nama_kelurahan}<br/>
											<span style={{fontSize:'9px'}}>Kecamatan : </span>{item?.alamat_domisili?.nama_kecamatan}<br/>
											<span style={{fontSize:'9px'}}>Kab/Kota : </span>{item?.alamat_domisili?.nama_kab_kot}<br/>
											<span style={{fontSize:'9px'}}>Provinsi : </span>{item?.alamat_domisili?.nama_provinsi}
										</div>
									</TableCell>
									{/* <TableCell style={{ padding:'8px', fontSize:'12px'}}>
										<div style={{ wordWrap: "break-word" }}>
											<img style={{width:"100%"}} src={`data:image/png;base64,${item?.data_ktp?.foto_ktp}`} alt={index}/>
										</div>
									</TableCell> */}
									<TableCell style={{ padding:'8px', fontSize:'12px'}}>
										{convertTime(item?.created_at)}
									</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          );
        })}
				</div>
      </TableContainer>
    </>
  );
}
